import { render } from "./UserUpdatePage.vue?vue&type=template&id=6ac5870d&ts=true"
import script from "./UserUpdatePage.vue?vue&type=script&lang=ts"
export * from "./UserUpdatePage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/Dashboard_HV/Dashboard_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__